// @flow
import React from 'react'

const Bill = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="22" viewBox="0 0 19 22">
      <g fill="none" fillRule="evenodd" stroke="#6E7B8C" strokeLinecap="square">
        <path d="M.5.5h18v21l-3-2-3 2-3-2-3 2-3-2-3 2zM4.5 14.5h5M13.5 14.5h1" />
        <circle cx="9.5" cy="7.5" r="3" />
      </g>
    </svg>
  )
}
export default Bill



// WEBPACK FOOTER //
// ./src/components/Icons/Bill.js